<template>
  <div style="height: 100%; width: 100%">

    <b-sidebar
        id="table-sidebar"
        :visible="isSideBarActive"
        bg-variant="white"
        right
        sidebar-class="sidebar-lg"
        shadow
        style="opacity: 0.94"
        :backdrop="false"
        no-header
        width="38%"
        @change="val => isSideBarActive = val">

      <template #default="{ hide }">

        <!-- Header -->
        <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
          <h5 class="mb-0">{{ $t('Containers') }}</h5>
          <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide"/>
        </div>

        <filters 
        :fields="[
            {
              key:'owner',
              title:'Owners',
              type:'list'
            },
            {
              key:'contract',
              title:'Contracts',
              type:'list'
            },
            {
              key:'type',
              title:'Types',
              type:'list'
            }
        ]" 
        :data="items" 
        :isBusy="!requestStatus"
        @filtereddd="(result) => filteredItems = result"
        @filtered="result => filterContainers(result)"
        />

        <div dir="rtl" class="m-2">

          <b-row class="mb-2">
            <!-- Per Page -->
            <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
              <label>{{ $t('Show') }}</label>
              <v-select
                  v-model="perPage" 
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="[20,50,100,500,1000]"
                  :clearable="false" 
                  class="per-page-selector d-inline-block mx-50"/>
              <label>{{ $t('entries') }}</label>
            </b-col>

            <!-- Search -->
            <b-col cols="12" md="6">
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input 
                  v-model="searchValue" 
                  class="d-inline-block mr-1" 
                  :placeholder="$t('Search...')"
                />
              </div>
            </b-col>
          </b-row>

          <b-table
              style="text-align: center"
              responsive small
              :current-page="currentPage"
              :per-page="perPage"
              :items="matchItems"
              :fields="fields.map((i) => ({ key: i.key, label: $t(i.key), sortable: i.sortable}))"
              show-empty :empty-text="$t('No matching records found')"
          >

            <template #cell(index)="data">
              {{ data.index + 1 }}
            </template>

            <template #cell(tag)="data">
              <b @click="fitContainer(data.item.tag)" class="text-info">{{ data.item.tag }}</b>
            </template>

          </b-table>

        </div>

        <div class="mx-2 mb-2 mt-2">
          <b-row>
            <!-- Pagination -->
            <b-col cols="12" class="d-flex align-items-center justify-content-center justify-content-sm-end">

              <b-pagination
                  v-model="currentPage" 
                  :total-rows="matchItems.length" 
                  :per-page="perPage"
                  first-number 
                  last-number
                  class="mb-0 mt-1 mt-sm-0" 
                  prev-class="prev-item" 
                  next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18"/>
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18"/>
                </template>
              </b-pagination>

            </b-col>
          </b-row>

          <span class="text-muted">
            Showing {{ (currentPage - 1) * perPage + 1 }} to {{ Math.min(currentPage * perPage, matchItems.length) }} from {{ matchItems.length }} entries
          </span>

        </div>

      </template>


    </b-sidebar>

<!--    <div class="vertical-menu">-->

<!--      <div class="menu-item" v-on:click="$router.push('/')">-->
<!--        <img width="20px" :src="require('@/assets/icons/dashboard.svg')" alt="">-->
<!--        Dashboard-->
<!--      </div>-->
<!--      <div class="menu-item" :class="{'is-active':isSideBarActive }"-->
<!--           @click="isSideBarActive = !isSideBarActive">-->
<!--        <img width="20px" :src="require('@/assets/icons/bin.svg')" alt="">-->
<!--        Containers-->
<!--      </div>-->

<!--    </div>-->

    <div id="mapObj" ref="mapElement" style="height: 100vh; width: 100%;"></div>
  </div>
</template>

<script>

import { ref, computed, onMounted, onBeforeUnmount } from '@vue/composition-api'
import L from 'leaflet';
import 'leaflet/dist/leaflet.css'
import axios from '@/libs/axios'
import { OrbitSpinner } from 'epic-spinners'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import ContainerPopup from '@/views/maps/GlobalContainerPopup.vue'
import { intPopup } from '@/ext/route.utilities'
import filters from '@/share/filters.vue'

import RouteHelper from '@/views/maps/RouteHelper'

import {
  BCollapse,
  BCard,
  BButton,
  BTable,
  BTr,
  BTd,
  BTableSimple,
  BCol,
  BSidebar,
  BDropdown,
  BDropdownItem, 
  BFormInput, 
  BPagination, 
  BFormCheckbox, 
  BRow, 
  VBTooltip, 
  VBToggle, 
  BCardHeader, 
  BCardBody
} from 'bootstrap-vue'
import router from '@/router'


export default {
  directives: {
    'b-tooltip': VBTooltip,
    'b-toggle': VBToggle,
    Ripple,
  },
  components: {
    filters,
    OrbitSpinner,
    BCardBody,
    BCardHeader,
    BRow,
    BFormCheckbox,
    vSelect,
    BPagination,
    BFormInput,
    BDropdownItem,
    BDropdown,
    BSidebar,
    BCol,
    BCollapse,
    BCard,
    BButton,
    BTable, 
    BTr, 
    BTd, 
    BTableSimple
  },
  setup() {

    let map = null
    let containers = []

    const requestStatus = ref(false)
    const searchValue = ref(null)
    const items = ref([])
    const filteredItems = ref([])
    const searchItems = (key)=> {
        return filteredItems.value.filter(item => {
          return searchValue.value ? ( item[key] ? item[key].includes(searchValue.value) : false) : true
        })
    }
    const matchItems = computed(() => {

      let matches = searchItems('tag');

      if(matches.length == 0){
        matches = searchItems('code');
      }

      return matches

    })
    const currentPage = ref(1)
    const perPage = ref(20)
    const fields = [{key:'index', title: '#'}, {key:'tag'}, {key:'code'},{key:"lastupdate", sortable: true}]
    const isSideBarActive = ref(false)
    const mapElement = ref(null)
    let bounds = new L.LatLngBounds();
    const containersGroup = L.layerGroup();


    const fitContainer = tag => {
      const latlng = containers[tag].getLatLng()
      map.flyTo(latlng);

      const m = L.marker(latlng, { icon:
            L.divIcon({ className: 'pulse', iconSize: [15, 15] }) }).addTo(map);

      (function(ms, me) {
        setTimeout(function() {
              map.removeLayer(m)
            }, ms
        );
      })(5000)

    }


    const drawContainers = (s) => {
      for (const i in s) {
        if (parseFloat(s[i].latitude)) {
          let container = create_container(s[i])
          containersGroup.addLayer(container)
          containers[s[i].tag] = container
          bounds.extend(container.getLatLng());
        }
      }
      map.flyToBounds(bounds);
    }

    const containerCircleOptions = {
      renderer: L.canvas({ padding: 0.5 }),
      fill: true,
      fillOpacity: 0.9,
      stroke: false,
      radius: 7,
    }

    const create_container = container => {

      const latLng = [
          container.latitude,
          container.longitude
      ]

      let color;
      const lastupdate_sec = (new Date() - new Date(container.lastupdate ?? null)) / 1000

      if (lastupdate_sec <= 24 * 3600) {
        color = '#3A865AFF';
      } else if (lastupdate_sec > 24 * 3600 && lastupdate_sec < 48 * 3600) {
        color = 'purple';
      } else {
        color = '#a91f0d';
      }

      let c = L.circleMarker(
          latLng,
          {
            ...containerCircleOptions,
            color: color
          })

      c.bindPopup(
          intPopup(
              ContainerPopup,
              container
          ), { closeButton: false,}
      )

      return c
    }



    const filterContainers = result => {

      bounds = L.latLngBounds();
      map.removeLayer(containersGroup)
      containersGroup.clearLayers()
      containers = []

      filteredItems.value = result
      drawContainers(result)
      containersGroup.addTo(map)
    }

    const getContainers = async () => {

      try {
        const res = await axios.get('getMapContainers', { params: {} })
        requestStatus.value = true
        if (res.status === 200) {
          items.value = res.data.containers

          drawContainers(res.data.containers)
          containersGroup.addTo(map)
        }
      }

      catch (e) {
        console.log(e)
      }
    }


    onMounted(() => {

      document.getElementsByTagName('html')[0].dir = "ltr"
      initMap()
      getContainers()


      const CustomControl = L.Control.extend({
        onAdd: function(map) {

          const container = L.DomUtil.create('div', 'custom-control')


          // containers
          const pathsButton = L.DomUtil.create('button', 'custom-button', container)
          const icon = L.DomUtil.create('img', 'button-icon', pathsButton);
          icon.src = require('@/assets/icons/path.png')

          pathsButton.addEventListener('click', function() {
            isSideBarActive.value = !isSideBarActive.value;
          })


          // dashboard
          const HomeButton = L.DomUtil.create('button', 'custom-button', container)
          const HomeIcon = L.DomUtil.create('img', 'button-icon', HomeButton);
          HomeIcon.src = require('@/assets/icons/home.png')

          HomeButton.addEventListener('click', function() {
            router.push({ name: 'dashboard' })
          })


          return container;
        }
      })

      const customControl = new CustomControl()
      customControl.addTo(map);

    })

    onBeforeUnmount(() => {
      map.remove()
    })

    const initMap = () => {

      map = L.map(mapElement.value, {center: [24.1307751,39.7842496], zoom: 6 })
      const googleStreets = L.tileLayer('https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', { maxZoom: 20, subdomains:['mt0','mt1','mt2','mt3'] }).addTo(map);
      const googleHybrid = L.tileLayer('https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}', { maxZoom: 20, subdomains:['mt0','mt1','mt2','mt3'] })
      L.control.layers({googleStreets, googleHybrid}, {},{ position: 'topleft'}).addTo(map)

      map.on('click', onMapClick);

    }

    const onMapClick = (event) => {

      // const { lat, lng } = event.latlng;
      // const { blue_points, red_points } = RouteHelper.splitRoute(routeLinePoints, [lat, lng])
      //
      // try {
      //   map.removeLayer(routeLine)
      //   map.removeLayer(routeLine2)
      // }
      // catch (e) {}
      //
      // routeLine = L.polyline(blue_points, {weight: 5, fillOpacity: 0.3, opacity: 0.5, color:'blue'}).addTo(map)
      // routeLine2 = L.polyline(red_points, {weight: 5, fillOpacity: 0.3, opacity: 0.5, color:'red'}).addTo(map)


      // const vv = L.marker([nearestPoint[0], nearestPoint[1]], {
      //       icon: L.divIcon({ className: 'pulse', iconSize: [15, 15] }) })
      //         .addTo(map);
      //
      // (function(ms) {
      //   setTimeout(function() {
      //         map.removeLayer(vv)
      //       }, ms
      //   );
      // })(5000)

    };

    return {
      items,
      filteredItems,
      matchItems,
      searchValue,
      requestStatus,
      perPage, 
      currentPage,
      fields, 
      isSideBarActive,
      mapElement,
      fitContainer,
      filterContainers
    }
  }



}


</script>

<style lang="less">

//.leaflet-popup-content-wrapper {
//  background: transparent;
//  box-shadow: none;
//  border-radius: 0;
//
//}

.button-icon {
  width: 25px;
}

.custom-button {
  all: unset;
  display: inline-block;
  cursor: pointer;

  background: white;
  margin: 2px;
  padding: 2px;
  border: 2px solid #1676e5;
  border-radius: 2px;

}


.pulse {
  background: rgb(163, 241, 9);
  border-radius: 50%;
  width: 20px;
  height: 20px;
  position: absolute;
  margin-left: -10px;
  margin-top: -10px;
  animation: pulse 1s ease-out infinite;
}


.vertical-menu {
  position: absolute;
  z-index: 999;
  right: 1px;
  display: flex;
  flex-direction: column;
  color: white;
  top:5px;
  border-radius: 2px;
}

.menu-item {
  display: flex;
  align-items: center;
  padding: 10px;
  text-align: center;
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  cursor: pointer;
  width: 30px;
  background-color: #161d31;
  margin: 1px;
}


.menu-item img {
  width: 20px;
  height: 20px;
  align-self: center;
  transform: rotate(180deg);
}

.menu-item:hover {
  background-color: #555;
}

.is-active {
  background-color: #555;
}


.pulse {
  background: rgb(163, 241, 9);
  border-radius: 50%;
  width: 20px;
  height: 20px;
  position: absolute;
  margin-left: -10px;
  margin-top: -10px;
  animation: pulse 1s ease-out infinite;
}


@keyframes pulse {
  0% {box-shadow: 0 0 0 0;}
  70% {box-shadow: 0 0 0 15px rgba(0, 0, 0, 0);}
  100% {box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);}
}


</style>